import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Relatorio } from './relatorio';
import { RelatorioService } from 'src/app/service/relatorio.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { Box } from '../box/box';

@Component({
  selector: 'app-relatorio',
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.scss']
})
export class RelatorioComponent implements OnInit {

  formularioGroups: FormGroup;
  tipoRelatorio: string;
  dataInicio: any;
  dataFim: any;
  cliente: any;
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; 
  mensagemErros: String[] = []; 
  tipoFiltros: String[] = ['Relatorio Venda Diária','Relatorio Venda A Receber','Relatorio Movimentação Caixa','Relatorio Venda Produto','Relatorio Comparativo Venda Produto','Relatorio Controle Proxima Troca Cliente'];
  tipoFiltro: any;
  boxs: Box[] = [];
  caixa: any;
  qtdMeses: any;
  qtdDias: any;

  constructor(private formBilder: FormBuilder,
    private relatorioService: RelatorioService,    
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private boxService: BoxService) {
   }

  ngOnInit(): void {
   
    
  }

 
}
